import { createFileRoute, redirect } from "@tanstack/react-router";
import { signOut } from "firebase/auth";
import { auth } from "@/firebase/app";
import { DASHBOARD_HOME } from "@/lib/routes";
import { getEntryWorkspace } from "@/lib/workspaces";
import { isAccountDeletedError } from "@/lib/trpcErrors";

export const Route = createFileRoute("/dashboard/")({
  beforeLoad: async ({ context }) => {
    // Don't fetch authenticated data until Firebase auth has resolved. The
    // parent /dashboard guard renders the shell (no redirect) while auth is
    // loading; firing getEntryWorkspace() here in that window would send a
    // tokenless getWorkspaces and 500 (#231). Once auth resolves,
    // router.invalidate() re-runs this — either the parent redirects to /login
    // (no user) or the fetch below runs with a real token.
    if (context.auth.isLoading) return;

    let workspace;
    try {
      workspace = await getEntryWorkspace();
    } catch (err) {
      if (isAccountDeletedError(err)) {
        try {
          await signOut(auth);
        } catch {
          /* ignore */
        }
        throw redirect({ to: "/account-deleted" });
      }
      throw err;
    }
    if (!workspace) {
      throw redirect({ to: "/" });
    }

    throw redirect({
      to: DASHBOARD_HOME,
      params: { workspaceId: workspace.workspaceId },
    });
  },
  component: DashboardIndexRedirect,
});

function DashboardIndexRedirect() {
  return null;
}
